export const TENANTS = `
query tenants(
  $tenant_id: Int!,
  $filter: FilterTenantInput,
  $orderBy:  TenantOrderInput,
  $skip: Int,
  $take: Int,
  $searchText: String,
) {
  tenants (
    tenant_id: $tenant_id,
    filter: $filter,
    orderBy: $orderBy
    skip: $skip
    take: $take
    searchText: $searchText
  ) {
    __typename
    ... on Tenant {
      id
      name
      slug
      active
      tenant_picture_id
      is_system_tenant
      tenant_picture {
        url
      }
      is_system_tenant
      country
      city
      chair_account {
        id
        status
        chair_id
        chair {
          contact_id
        }
      }
      exhibitor_account {
        id
        status
        exhibitor_id
      }     
      its
      invoice_identification_type_id
      invoice_identification
      invoice_company_name
      owner_email
      owner_user{
        id
        username
        email
        contact {
          id
          firstname
          lastname
        }
      }
    }
    ... on ResultError {
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const TENANT = `
query tenant($tenant_id: Int!,$input: GetTenantInput!) {
  tenant(input: $input, tenant_id: $tenant_id) {
    __typename
    ... on Tenant {
      id
      name
      slug
      active
      is_system_tenant
      tenant_picture_id
      tenant_picture{
        filename
        mimetype              
        url
      }
      transport_company
      city
      country
      chair_account {
        id
        status
        chair_id
        chair {
          contact_id
        }
      }
      exhibitor_account {
        id
        status
        exhibitor_id
      }  
      invoice_identification_type_id
      invoice_identification
      invoice_company_name
      owner_email
      owner_user{
        id
        username
        email
        contact {
          id
          firstname
          lastname
        }
      }
    }
    ... on ResultError {
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const TENANT_COUNT = `
query tenantCount($tenant_id: Int!,$filter: FilterTenantInput, $orderBy: TenantOrderInput, $searchText: String) {
  tenantCount(tenant_id: $tenant_id, filter: $filter, orderBy: $orderBy, searchText: $searchText) {
    __typename
    ... on Count {
      count
    }
    ... on ResultError {
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const GET_TENANT_PICTURE = `
query getTenantPicture($tenant_id: Int!, $id: Int!){
  getTenantPicture(tenant_id: $tenant_id, id:$id){
    __typename
    ... on StringResult{
      result
    }
    ... on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const TENANTS_ASSOCIATED_WITH_USER = `
query tenantsAssociatedWithUser(
  $tenant_id: Int!
  $includeAllAccessible: Boolean
  $includeInactive: Boolean
) {
  tenantsAssociatedWithUser(
    tenant_id: $tenant_id
    includeAllAccessible: $includeAllAccessible
    includeInactive: $includeInactive
  ) {
    __typename
    ... on Tenant {
      id
      its
      uts
      name
      slug
      active
      tenant_picture_id
      is_system_tenant
      tenant_picture {
        id
        its
        uts
        filename
        mimetype
        encoding
        file
        url
      }
      chair_account {
        id
        status
        chair_id
        chair {
          contact_id
        }
      }
      exhibitor_account {
        id
        status
        exhibitor_id
      }  
      invoice_identification_type_id
      invoice_identification
      invoice_company_name
      owner_email
      owner_user {
        id
        username
        email
      }
    }
    ... on ResultError {
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const TENANT_FOR_ACCOUNT_BANK_INFORMATION = `
query tenantForWalletBalance(
  $tenant_id: Int!,
  $input: GetTenantInput!
) {
  tenant(
    input: $input, 
    tenant_id: $tenant_id
  ) {
    __typename
    ... on Tenant {      
      bank_account_cbu
      bank_account_alias
      bank_account_holder
      bank_account_identification
      bank_account_identification_type_id
    }
    ... on ResultError {
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const TENANT_HAS_BANK_INFORMATION = `
query tenantHasBankInformation(
  $tenant_id: Int!,
  $id: Int!
){
  tenantHasBankInformation(
    tenant_id:$tenant_id,
    id:$id
  ){
    __typename
    ...on TenantHasBankInformation{
      tenantHasBankInformation
    }
    ...on ResultError{
      status_code
      message
     	message_translation_key
    }
  }
}
`;

export const TENANT_HAS_NECESSARY_INFORMATION = `
query tenantHasNecessaryInformation(
  $tenant_id: Int!,
  $id: Int!
){
  tenantHasNecessaryInformation(
    tenant_id:$tenant_id,
    id:$id
  ){
    __typename
    ...on TenantHasNecessaryInformation {
      tenantHasNecessaryInformation
    }
    ...on ResultError{
      status_code
      message
     	message_translation_key
    }
  }
}
`;
